import React, { useState } from "react";
import ModalVideo from "react-modal-video";

const VideoPopupTwo = ({ spaceBottomClass }) => {
  const [modalStatus, isOpen] = useState(false);
  return (
    <div
      className={`video-popup-2 ${spaceBottomClass ? spaceBottomClass : ""}`}
    >
      <div
        className="video-popup-2__left bg-img"
        style={{
          backgroundImage: `url(${
            process.env.PUBLIC_URL + "/assets/zebra_images/covers/coding-1.webp"
          })`,
        }}
      >
        <div className="video-popup-2__content"></div>
        <ModalVideo
          channel="youtube"
          isOpen={modalStatus}
          videoId="O_PZ8x6z6Ao"
          onClose={() => isOpen(false)}
        />
        <div className="video-popup-2__button">
          <button onClick={() => isOpen(true)}>
            <img
              src={process.env.PUBLIC_URL + "/assets/img/icon-img/play.png"}
              alt=""
            />
          </button>
        </div>
      </div>
      <div
        className="video-popup-2__right bg-img"
        style={{
          backgroundImage: `url(${
            process.env.PUBLIC_URL + "/assets/zebra_images/covers/juniors3.webp"
          })`,
        }}
      ></div>
    </div>
  );
};

export default VideoPopupTwo;
